export const monthsFieldWrapperStyles = {
  position: 'relative',
  minWidth: 0,
};

export const lockedFieldTooltipAnchorStyles = {
  minWidth: 0,
};
